'use client';

import { Button } from '@vertex-protocol/web-ui';
import { useSetAtom } from 'jotai';
import { debugChatOpenAtom } from 'client/modules/debugChat/atoms/debugChatAtoms';
import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';

export function NeedHelpButton() {
  const { show } = useDialog();
  const setDebugChatOpen = useSetAtom(debugChatOpenAtom);

  const handleClick = () => {
    if (process.env.NEXT_PUBLIC_DEBUG_CHAT_ENABLED === 'true') {
      setDebugChatOpen(true);
    } else {
      show({ type: 'help_center', params: {} });
    }
  };

  return (
    <Button
      className="text-text-secondary hover:text-text-primary"
      onClick={handleClick}
    >
      Need Help?
    </Button>
  );
}
